import { lazy } from 'react';

// Lazy loading dos componentes
const Home = lazy(() => import('../pages/Home'));
const Profile = lazy(() => import('../components/profile/Profile'));
const AdminDashboard = lazy(() => import('../components/admin/AdminDashboard'));
const UserDashboard = lazy(() => import('../components/user/UserDashboard'));
const ClientDashboard = lazy(() => import('../components/client/ClientDashboard'));
const TaxTabs = lazy(() => import('../components/user/TaxTabs'));

// Configuração das rotas
export const routes = {
  public: [
    {
      path: '/',
      element: Home,
      layout: 'base'
    }
  ],
  protected: [
    {
      path: '/profile',
      element: Profile,
      layout: 'dashboard'
    }
  ],
  admin: [
    {
      path: '/admin',
      element: AdminDashboard,
      layout: 'dashboard',
      children: [
        {
          path: 'dashboard',
          element: AdminDashboard
        }
      ]
    }
  ],
  user: [
    {
      path: '/user',
      element: UserDashboard,
      layout: 'dashboard',
      children: [
        {
          path: 'dashboard',
          element: UserDashboard
        },
        {
          path: 'tax',
          element: TaxTabs
        }
      ]
    }
  ],
  client: [
    {
      path: '/client',
      element: ClientDashboard,
      layout: 'dashboard',
      children: [
        {
          path: 'dashboard',
          element: ClientDashboard
        }
      ]
    }
  ]
};
